import {
    DEALERADDUPDATETHANALIST_SUCCESS,
    DEALERADDUPDATETHANALIST_FAILED,
    RESET_DEALERADDUPDATETHANALIST,
    LOADING_DEALERADDUPDATETHANALIST,
    NETWORK_ERROR_DEALERADDUPDATETHANALIST
} from "../types/index"

import { dealerServices } from "../../config/axios";


const resetDealerAddUpdateThanaList = () => {
    return { type: RESET_DEALERADDUPDATETHANALIST };
};



const dealerAddUpdateThanaList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDUPDATETHANALIST });
    await dealerServices
        .post("thanaList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddUpdateThanaListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddUpdateThanaListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDUPDATETHANALIST,
                payload: err
            });
        });
}


function dealerAddUpdateThanaListsuccess(data) {
    return {
        type: DEALERADDUPDATETHANALIST_SUCCESS,
        payload: data
    };
}
function dealerAddUpdateThanaListFailed(data) {
    return {
        type: DEALERADDUPDATETHANALIST_FAILED,
        payload: data
    };
}
export { resetDealerAddUpdateThanaList, dealerAddUpdateThanaList }